(() => {
  const root = document.querySelector('.ulike-ipl-live');
  if (!root) return;
  const report = message => {
    let notice = root.querySelector('[data-ipl-cart-status]');
    if (!notice) {
      notice = document.createElement('p');
      notice.dataset.iplCartStatus = '';
      notice.setAttribute('role', 'alert');
      root.prepend(notice);
    }
    notice.textContent = message;
  };
  window.ulikeIplAddToCart = async (id, code) => {
    if (!/^\d+$/.test(String(id))) throw new Error('Missing product variant');
    const base = window.Shopify?.routes?.root || '/';
    try {
      if (code) {
        const discount = await fetch(`${base}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(base + 'cart')}`);
        if (!discount.ok) throw new Error('Unable to apply the offer. Please try again.');
      }
      const response = await fetch(`${base}cart/add.js`, {
        method: 'POST', headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: JSON.stringify({items:[{id:String(id),quantity:1}],sections:['mini-cart']})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to add this item. Please try again.');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true,detail:{openMiniCart:true}}));
      report('Added to cart.');
      return data;
    } catch (error) { report(error.message); throw error; }
  };
  const toggleFaq = title => {
    const item = title.closest('.faq-item');
    const box = title.closest('.faq-box');
    const open = !item.classList.contains('active');
    box.querySelectorAll('.faq-item').forEach(row => {
      const active = row === item && open;
      row.classList.toggle('active',active);
      row.querySelector('.faq-item-title')?.setAttribute('aria-expanded',String(active));
      const panel = row.querySelector('.faq-item-cont');
      if (panel) panel.style.display = active ? 'block' : 'none';
    });
    box.classList.toggle('open-active',open);
  };
  root.addEventListener('click', async event => {
    const title = event.target.closest('.faq-item-title');
    if (title) toggleFaq(title);
    const button = event.target.closest('button[data-pid]');
    if (!button || button.disabled) return;
    button.disabled = true;
    try { await window.ulikeIplAddToCart(button.dataset.pid,button.dataset.code); }
    catch (_) { /* The inline status reports the failure. */ }
    finally { button.disabled = false; }
  });
  root.addEventListener('keydown', event => {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.faq-item-title')) {
      event.preventDefault();toggleFaq(event.target);
    }
  });
})();
